import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';

export const trustSettingsQueryKey = ['surfaces', 'trust', 'settings'] as const;

// Mirrors GET /api/surfaces/trust/settings (Next + Supabase, trust_settings row).
export interface TrustSettings {
  kill_switch: boolean;
  capture_paused: boolean;
  redaction_rules: unknown[];
  source_permissions: Record<string, string>;
  default_zone: 'public' | 'private' | 'secret';
}

export function useTrustSettings() {
  const query = useQuery({
    queryKey: trustSettingsQueryKey,
    queryFn: () => apiFetch<TrustSettings>('/api/surfaces/trust/settings'),
    staleTime: 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
  return { ...query, data: query.data ?? undefined };
}
